import type { ReferenceImagePayload } from "../../EntityImage/lib/types";
import { CropView, getCropRegion, getOutputSize, Size } from "./cropRect";

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Failed to load the image"));
    image.src = src;
  });
}

export async function cropCoverImage(src: string, view: CropView): Promise<ReferenceImagePayload> {
  const image = await loadImage(src);
  const source: Size = { width: image.naturalWidth, height: image.naturalHeight };
  const region = getCropRegion(source, view);
  const output = getOutputSize(region);

  const canvas = document.createElement("canvas");
  canvas.width = output.width;
  canvas.height = output.height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas is unavailable");

  // JPEG has no alpha, so transparent PNG/GIF areas would otherwise turn black.
  context.fillStyle = "#fff";
  context.fillRect(0, 0, output.width, output.height);
  context.drawImage(image, region.x, region.y, region.width, region.height, 0, 0, output.width, output.height);

  const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
  const base64 = dataUrl.split(",", 2)[1];
  if (!base64) throw new Error("Failed to encode the cropped image");
  return { mimeType: "image/jpeg", base64 };
}
